import { showError, showSuccess } from '../../../common/A1Alert/A1Alert';
import Api from '../../../helpers/Api';

export const SET_SUBMITTING_FREESTREAMINGMODAL = 'SET_SUBMITTING_FREESTREAMINGMODAL';
const setSubmitting = () => ({
    type: SET_SUBMITTING_FREESTREAMINGMODAL,
});

export const UNSET_SUBMITTING_FREESTREAMINGMODAL = 'UNSET_SUBMITTING_FREESTREAMINGMODAL';
const unsetSubmitting = () => ({
    type: UNSET_SUBMITTING_FREESTREAMINGMODAL,
});

export const SET_SUBMITTED_FREESTREAMINGMODAL = 'SET_SUBMITTED_FREESTREAMINGMODAL';
const setSubmitted = () => ({
    type: SET_SUBMITTED_FREESTREAMINGMODAL,
});

export const sendMessage = (data) => (dispatch) => {
    dispatch(setSubmitting());

    const query = 'api/v1/freeStreaming/sendMessage';

    return Api.progressPost(dispatch, query, data)
        .then((json) => {
            dispatch(unsetSubmitting());

            if (json.status === 'success') {
                dispatch(setSubmitted());

                showSuccess('Sua solicitação foi enviada! Retornaremos em breve :)');
            } else {
                showError(json.message);

                throw `error from server: ${json.message}`;
            }
        }).catch((error) => {
            dispatch(unsetSubmitting());

            showError('Problema na comunicação com servidor, por favor tente novamente em alguns instantes');

            throw `message got ${error}`;
        });
};
